import React from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { AllieLoading } from '@allie/app-ui-lib';
import { TokenValidationError } from '../../components/TokenValidationError';
import { CreatePassword } from '../../components/CreatePassword';
import { CommonPageProps } from '../../App.types';
import { useAppTranslations } from '../../hooks';
import { VALIDATE_TOKEN } from '../../data';
import './ResetPasswordPage.scss';

export const ResetPasswordPage: React.FC<CommonPageProps> = () => {
  const { search } = useLocation();
  const { CREATE_NEW_PASSWORD_INVALID_TOKEN, VALIDATING_TOKEN } = useAppTranslations();

  const token = new URLSearchParams(search).get('token');

  const { data, loading, error } = useQuery(VALIDATE_TOKEN, { variables: { token } })

  if (error || (!loading && data?.validateToken === null)) {
    return <TokenValidationError message={CREATE_NEW_PASSWORD_INVALID_TOKEN} />;
  }

  return (
    loading ? (
      <AllieLoading isOpen={loading} message={VALIDATING_TOKEN} />
    ) : (
      <CreatePassword email={data!.validateToken.email} id={data!.validateToken.id} />
    )
  );
};
